import { classNames, Separator, type SeparatorProps } from "@opensea/ui-kit"

type Props = SeparatorProps

export function FilterSidePanelDivider({ className, ...rest }: Props) {
  return <Separator className={classNames("my-4", className)} {...rest} />
}
